import { useCallback, useMemo } from "react";
import { Dropdown } from "antd";
import className from "classname";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { useChangeLanguage } from "queries/user";
import { useSelector } from "react-redux";
import { langSelector, localeSelector } from "appredux/selectors";

const LaguangeSelector = () => {
  const lang = useSelector(langSelector);
  const locale = useSelector(localeSelector);
  const changeLanguage = useChangeLanguage();

  const language = locale.substr(0, 2);

  const onChangeLanguage = useCallback(
    ({ key }) => {
      changeLanguage.mutate({ locale: key });
    },
    [changeLanguage]
  );

  const menuItems = useMemo(() => {
    const items = (lang || [])?.map((item) => ({
      key: item?.value,
      label: item?.name,
      icon: (
        <div
          className={className(
            "rounded-full w-6 h-6 flex items-center justify-center",
            item?.value === locale ? "bg-green-400" : "bg-gray-300"
          )}
        >
          <span className="uppercase">{(item?.value || "")?.substr(0, 2)}</span>
        </div>
      ),
    }));
    return items;
  }, [lang, locale]);

  return (
    <Dropdown
      overlayClassName="pt-0"
      placement="bottomRight"
      menu={{
        items: menuItems,
        selectedKeys: [locale],
        onClick: onChangeLanguage,
      }}
      trigger={["click"]}
    >
      <div className="flex flex-row items-center gap-1 cursor-pointer">
        <span className="font-medium uppercase">{language}</span>
        <MdOutlineArrowDropDown />
      </div>
    </Dropdown>
  );
};

export default LaguangeSelector;
